import React from 'react'

import labels from '../../configuration/labels'
import '../../styles/scss/elements/tour-details.scss'

const TourDetails = props => {
  const {
    background,
    containerClasses,
    highlights,
    included,
    isGetaway,
  } = props

  return (
    <div id="tour-details" className={`tour-details ${containerClasses}` }>
      {background && (
        <div className="tour-details__background-image" style={{backgroundImage: `url("${background}")`}}>
          <div className="triangle__bottom-right"></div>
          <div className="rectangle__bottom-right"></div>
        </div>
      )}
      <div className="tour-details__outer">
        <h2 dangerouslySetInnerHTML={{ __html: labels.tourDetailsHeader }}/>
        <div className="tour-details__outer__divider" />
        <div className="tour-details__content">
          {highlights && (
            <div className={`tour-details__content__column ${!included || included.length === 0 ? 'wide' : ''}`}>
              <h4 dangerouslySetInnerHTML={{ __html: isGetaway ? labels.tourGetawayAVTripHighlightsHeader : labels.tourDetailsTripHighlightsHeader }}/>
              <div className="tour-details__content__column__highlights" dangerouslySetInnerHTML={{__html: highlights}} />
            </div>
          )}
          {included && (
            <div className={`tour-details__content__column ${!highlights || highlights.length === 0 ? 'wide' : ''}`}>
              <h4 dangerouslySetInnerHTML={{ __html: labels.tourDetailsWhatsIncludedHeader }}/>
              <div className="tour-details__content__column__included" dangerouslySetInnerHTML={{__html: included}} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TourDetails